import { ChevronDown, ChevronLeft, ChevronRight, Home, Menu, MessageSquare, X } from "lucide-react";
import ToolIcon from "./ToolIcon";

export function NavigationToggle({ open, onToggle }) {
  return <button className="theme-toggle mobile-nav-toggle" type="button" onClick={onToggle} aria-label={open ? "Close navigation" : "Open navigation"} aria-expanded={open}><span aria-hidden="true">{open ? <X size={16} /> : <Menu size={16} />}</span><span className="mobile-nav-label">{open ? "Close" : "Menu"}</span></button>;
}

export default function ResourceSidebar({
  collapsed,
  mobileOpen,
  groups,
  tools,
  expandedGroups,
  activeGroup,
  selectedTool,
  production = false,
  onToggleCollapsed,
  onToggleGroup,
  onSelectHome,
  onSelectGroup,
  onSelectTool,
  onFeedback,
  onCloseMobile,
}) {
  return <>
    {mobileOpen && <button className="sidebar-backdrop" aria-label="Close navigation" onClick={onCloseMobile} />}
    <aside className={`concept-sidebar${production ? " production-sidebar" : ""}${collapsed ? " sidebar-collapsed" : ""}`} aria-label="Resource center navigation">
      {production ? <>
        <div className="sidebar-brand">
          <div className="sidebar-brand-stack">
            {!collapsed && <div className="sidebar-brand-logo-wrap"><img src={`${process.env.PUBLIC_URL || ""}/Logos/Koch-Technology-Lockup-horz-digital-black.ai.png`} alt="Koch Technology" className="sidebar-brand-logo" /></div>}
            {collapsed && <div className="logo-mark sidebar-brand-mark">K</div>}
          </div>
          <button className="sidebar-collapse-btn" type="button" onClick={onToggleCollapsed} title={collapsed ? "Expand" : "Collapse"} aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}>{collapsed ? <ChevronRight size={15} /> : <ChevronLeft size={15} />}</button>
        </div>
      </> : <div className="sidebar-top"><span className="sidebar-heading">{collapsed ? "" : "NAVIGATION"}</span><button className="sidebar-collapse" type="button" onClick={onToggleCollapsed} aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"} title={collapsed ? "Expand sidebar" : "Collapse sidebar"}>{collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}</button></div>}
      <button className={`sidebar-link${activeGroup === "All tools" ? " current" : ""}`} title={collapsed ? "Home" : undefined} onClick={onSelectHome}><Home size={17} /><span className="sidebar-nav-label">Home<small>Resource Center</small></span></button>
      {!collapsed && <div className="sidebar-heading sidebar-spaced">TOOLS</div>}
      <nav className="sidebar-groups" aria-label="Tool groups">
        {groups.map((group) => {
          const groupTools = tools.filter((tool) => tool.group === group);
          const expanded = !collapsed && Boolean(expandedGroups[group]);
          return <section className="sidebar-group-section" key={group}>
            <button className={`sidebar-group-button${expanded ? " expanded" : ""}${activeGroup === group ? " active" : ""}`} type="button" title={collapsed ? group : undefined} aria-label={collapsed ? group : undefined} aria-expanded={collapsed ? undefined : expanded} onClick={() => { onSelectGroup(group); onToggleGroup(group); }}>
              <span className="sidebar-group-icon"><ToolIcon toolId={groupTools[0].id} size={16} /></span>
              {!collapsed && <><span className="sidebar-group-name">{group}</span><b>{String(groupTools.length).padStart(2, "0")}</b>{expanded ? <ChevronDown size={14} /> : <ChevronRight size={14} />}</>}
            </button>
            {expanded && <div className="sidebar-tool-list">{groupTools.map((tool) => <button className={`sidebar-tool${selectedTool === tool.name ? " selected" : ""}`} key={tool.id} type="button" onClick={() => onSelectTool(tool)} title={tool.name}><span className="sidebar-tool-icon"><ToolIcon toolId={tool.id} size={14} /></span><span>{tool.name}</span></button>)}</div>}
          </section>;
        })}
      </nav>
      {production && onFeedback && <div className="sidebar-feedback-wrap">
        <button className="sidebar-feedback-link" type="button" onClick={onFeedback} title={collapsed ? "Provide feedback" : undefined}>
          <MessageSquare size={16} aria-hidden="true" />
          {!collapsed && <span>Provide feedback</span>}
        </button>
      </div>}
      <div className="sidebar-foot"><span className="sidebar-status" />{!collapsed && <>All systems operational<small>HRT Security & Infrastructure</small></>}</div>
    </aside>
  </>;
}